import React from "react";

import PropTypes from "prop-types";

import { Box, Tab, Tabs } from "@mui/material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import ParkIcon from "@mui/icons-material/Park";
import MapIcon from "@mui/icons-material/Map";
import GroupsIcon from "@mui/icons-material/Groups";
import CategoryCheckboxList from "./layers/CategoryCheckboxList";
import { useRecoilValue } from "recoil";
import { selectedFocusAreaAtom } from "../map/selectedRegionAtoms";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function SidebarTabsContainer({ sx, isMobile, ...other }) {
  const [tabValue, setTabValue] = React.useState(0);
  const selectedFocusArea = useRecoilValue(selectedFocusAreaAtom);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!selectedFocusArea) {
    return (<Box sx={{ ...sx }} />)
  }

  let tabPanelStyle = {
    flexGrow: 1,
  }

  if (!isMobile) {
    tabPanelStyle = {
      ...tabPanelStyle,
      flexBasis: "1px",
      overflowY: "auto"
    }
  }

  return (
    <Box sx={{
      ...sx,
      width: "100%",
      display: "flex",
      flexDirection: "column",
    }} {...other}>
      <Box className="layers-tabs" sx={{ height: "80px" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="map-tabs"
          selectionFollowsFocus
          variant="fullWidth">
          <Tab
            icon={<DesignServicesIcon />}
            disableRipple
            label={"Planning"}
            aria-label="planning"
          />

          <Tab
            icon={<GroupsIcon />}
            disableRipple
            label={"Culture"}
            aria-label="culture"
          />
          <Tab
            icon={<ParkIcon />}
            disableRipple
            label={"Environment"}
            aria-label="environment"
          />
          <Tab
            icon={<MapIcon />}
            disableRipple
            label={"HSDS"}
            aria-label="hsds"
          />
        </Tabs>
      </Box>
      <Box
        className="layer-check-boxes"
        sx={tabPanelStyle}>
        <TabPanel value={tabValue} index={0}>
          <CategoryCheckboxList category="planning" />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <CategoryCheckboxList category="culture" />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <CategoryCheckboxList category="environment" />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <CategoryCheckboxList category="hsds" />
        </TabPanel>
      </Box>
    </Box>
  );
}

export default SidebarTabsContainer;
